import { render, staticRenderFns } from "./CancelNotificationExtra.vue?vue&type=template&id=39e07313&scoped=true&"
import script from "./CancelNotificationExtra.vue?vue&type=script&lang=js&"
export * from "./CancelNotificationExtra.vue?vue&type=script&lang=js&"
import style0 from "./CancelNotificationExtra.vue?vue&type=style&index=0&id=39e07313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e07313",
  null
  
)

export default component.exports